import React from "react";
import { Route, Switch } from "react-router-dom";
import { Login, PasswordRecovery } from "./pages";
import { useRedirectIfAuthenticated } from "./hooks";

import { Main } from "./global";

const Authentication = function () {
  useRedirectIfAuthenticated();

  return (
    <Main>
      <Switch>
        <Route exact path="/authentication" component={Login} />
        <Route exact path="/authentication/password_recovery" component={PasswordRecovery} />
      </Switch>
    </Main>
  );
};

export default Authentication;
